class FaqsSearch {
  constructor(options) {
    this.contentBox = document.querySelector(options.content)
    this.titleList = this.contentBox.querySelectorAll('.panel')
    this.titleLenght = this.titleList.length
    this.searchDom = document.querySelector(options.searchBox)
    this.nullBox = document.querySelector('.page-faq .faqs-null')
    this.init()
  }
  init () {
    this.searchDom.addEventListener('input', (e) => {
      console.log(e.target.value)
      if (e.target.value) {
        let num = 0
        this.titleList.forEach((i, index) => {
          const title = i.querySelector('.panel-title a span').innerHTML
          const content = i.querySelector('.panel-body div .rte').innerHTML

          const r = e.target.value.toLocaleLowerCase()

          if (title.toLocaleLowerCase().includes(r) || content.toLocaleLowerCase().includes(r)) {
            i.style.display = 'block'
          } else {
            i.style.display = 'none'
            num++
          }
        })
        this.nullBox.style.display = num === this.titleLenght ? 'block' : 'none'
      } else {
        this.titleList.forEach(i => {
          i.style.display = 'block'
        })
        this.nullBox.style.display = 'none'
      }
    })
  }
}
